import { defineField, defineType } from "sanity";

export default defineType({
  name: "simpleBlocContentWrap",
  type: "object",
  title: "Text",
  fields: [
    defineField({
      name: "text",
      type: "simpleBlocContent"
    })
  ],

  preview: {
    prepare(selection) {
      return {
        ...selection,
        title: "Text Content"
      };
    }
  }
});
